import React, {Component} from 'react';
import printYear from '../core/CollectionHelper';
import Lightbox from "react-image-lightbox";
import {withTranslation} from "react-i18next";


class Page extends Component {
    constructor(props) {
        super(props)

        this.state = {
            photoUrl: null,
            isOpen: false,
        }
    }


    imgClickHandler = (e, url) => {
        e.preventDefault();
        this.setState({photoUrl: url, isOpen: true});
    };

    render() {
        const {t} = this.props;
        const data = t('collections', {returnObjects: true});
        const {isOpen, photoUrl} = this.state;
        const name = this.props.match.params.name
        const album = this.getAlbum(name, data);
        const photos = album.photos.map((item, i) => {
            return (
                <div key={i} className='collection-block' style={{border: '0px solid yellow'}}>
                    <div className='collection-main-photo'
                         style={{
                             backgroundImage: `url(/img/collections/${album.dirName}/${item.previewPath})`,
                         }}
                         onClick={e => {
                             this.imgClickHandler(e, `/img/collections/${album.dirName}/${item.fullSizePath}`)
                         }}
                    ></div>
                </div>)
        })

        return (
            <div className='container collections'>
                {isOpen && (
                    <Lightbox
                        mainSrc={photoUrl}
                        onCloseRequest={() => this.setState({isOpen: false})}
                    />
                )}
                <div className='text-center text-uppercase'>
                    <h4>
                        <span className='underlined'>{name}</span>
                    </h4>
                    <div>
                        {printYear(album.year, album.season)}
                    </div>
                </div>
                {/*Фотографий: {album.photos.length}*/}
                <div className='row margin-top-default'>
                    {photos}
                </div>
            </div>
        );
    }

    getAlbum = (name, data) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name === name)
                return data[i];
        }
        return null
    }
}

const CollectionDetails = withTranslation()(Page);
export default CollectionDetails;


// WEBPACK FOOTER //
// ./src/components/CollectionDetails.jsx